module.exports = __webpack_public_path__ + "img/infoOur.09ff21c4.webp";